/* 9th at Nine — storefront behaviour */
(function () {
  var d = document;
  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };

  /* back link: use real history when the visitor came from within the store */
  d.querySelectorAll('[data-back]').forEach(function (link) {
    var internal = document.referrer && document.referrer.indexOf(location.origin) === 0;
    if (!internal || history.length < 2) return;
    link.addEventListener('click', function (e) { e.preventDefault(); history.back(); });
  });

  /* announcement bar: rotate, dismiss, copy code */
  var announce = d.querySelector('[data-announce]');
  var syncChrome = function () {
    var bar = d.querySelector('[data-announce]');
    var barH = (bar && !bar.hidden) ? Math.round(bar.getBoundingClientRect().height) : 0;
    d.documentElement.style.setProperty('--announce-h', barH + 'px');
    var hd = d.querySelector('[data-header]');
    if (hd) d.documentElement.style.setProperty('--header-h', Math.round(hd.getBoundingClientRect().height) + 'px');
  };
  syncChrome();
  window.addEventListener('resize', syncChrome);
  window.addEventListener('load', syncChrome);
  if (announce) {
    if (sessionStorage.getItem('n9-announce-closed') === '1') { announce.hidden = true; syncChrome(); }
    var closeBtn = announce.querySelector('[data-announce-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      announce.hidden = true;
      try { sessionStorage.setItem('n9-announce-closed', '1'); } catch (e) {}
      syncChrome();
    });
    var items = announce.querySelectorAll('[data-announce-item]');
    if (items.length > 1) {
      var ai = 0;
      items[0].classList.add('is-on');
      setInterval(function () {
        items[ai].classList.remove('is-on');
        ai = (ai + 1) % items.length;
        items[ai].classList.add('is-on');
      }, 6000);
    } else if (items.length === 1) {
      items[0].classList.add('is-on');
    }
    announce.querySelectorAll('[data-copy]').forEach(function (chip) {
      var copy = function () {
        var code = chip.dataset.copy;
        if (navigator.clipboard) navigator.clipboard.writeText(code);
        var was = chip.textContent;
        chip.textContent = 'Copied';
        setTimeout(function () { chip.textContent = was; }, 1600);
      };
      chip.addEventListener('click', copy);
      chip.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copy(); } });
    });
  }

  /* header: transparent over hero, ivory once scrolled */
  var header = d.querySelector('[data-header]');
  if (header) {
    var overlay = header.hasAttribute('data-overlay');
    var setState = function () {
      var past = window.scrollY > (overlay ? window.innerHeight * 0.78 : 8);
      header.classList.toggle('is-solid', past || !overlay);
    };
    setState();
    window.addEventListener('scroll', setState, { passive: true });
  }

  /* mobile menu */
  var menuBtn = d.querySelector('[data-menu-toggle]');
  var menu = d.querySelector('[data-menu]');
  on(menuBtn, 'click', function () {
    var open = menu.classList.toggle('is-open');
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.style.maxHeight = open ? menu.scrollHeight + 'px' : '0px';
  });

  /* reveal on scroll. In the theme editor Shopify re-renders sections over AJAX
     without re-running this file, so we never hide anything there. */
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var io = null;
  if (!designMode && 'IntersectionObserver' in window) {
    d.documentElement.classList.add('js-reveal');
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    d.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }
  var observeReveals = function (root) {
    if (!io) return;
    (root || d).querySelectorAll('.reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
  };

  /* parallax */
  var px = d.querySelectorAll('[data-parallax]');
  if (px.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var ticking = false;
    var run = function () {
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translateY(' + (p * -24) + 'px)';
      });
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(function () { run(); ticking = false; }); ticking = true; }
    }, { passive: true });
    run();
  }

  /* draggable strips */
  var bindDrag = function (root) {
  (root || d).querySelectorAll('[data-drag]').forEach(function (g) {
    if (g.dataset.dragBound === '1') return;
    g.dataset.dragBound = '1';
    var down = false, sx = 0, sl = 0, moved = false;
    on(g, 'pointerdown', function (e) { down = true; moved = false; sx = e.clientX; sl = g.scrollLeft; g.setPointerCapture(e.pointerId); g.style.cursor = 'grabbing'; });
    on(g, 'pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; g.scrollLeft = sl - dx; });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      on(g, ev, function (e) { down = false; g.style.cursor = 'grab'; try { g.releasePointerCapture(e.pointerId); } catch (x) {} });
    });
    g.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });
  };
  bindDrag();

  /* toast */
  var toast = d.querySelector('[data-toast]');
  var tt;
  window.n9Toast = function (msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-up');
    clearTimeout(tt);
    tt = setTimeout(function () { toast.classList.remove('is-up'); }, 2600);
  };

  /* cart drawer + AJAX cart */
  var drawer = d.querySelector('[data-cart-drawer]');
  var scrim = d.querySelector('[data-cart-scrim]');
  var openDrawer = function () { if (!drawer) return; drawer.classList.add('is-open'); scrim.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); };
  var closeDrawer = function () { if (!drawer) return; drawer.classList.remove('is-open'); scrim.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); };
  window.n9OpenCart = openDrawer;
  d.querySelectorAll('[data-cart-open]').forEach(function (b) { on(b, 'click', function (e) { if (drawer) { e.preventDefault(); refresh().then(openDrawer); } }); });
  d.querySelectorAll('[data-cart-close]').forEach(function (b) { on(b, 'click', closeDrawer); });
  on(scrim, 'click', closeDrawer);
  on(window, 'keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function refresh() {
    var body = d.querySelector('[data-cart-body]');
    if (!body) return Promise.resolve();
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer-items')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-body]');
        if (fresh) body.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-cart-count]');
        d.querySelectorAll('[data-cart-count]').forEach(function (el) { if (count) el.textContent = count.textContent; });
        var total = doc.querySelector('[data-cart-total]');
        d.querySelectorAll('[data-cart-total]').forEach(function (el) { if (total) el.textContent = total.textContent; });
        bindLines();
      });
  }

  function change(line, qty) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(refresh);
  }

  function bindLines() {
    d.querySelectorAll('[data-line-remove]').forEach(function (b) {
      b.onclick = function () { change(parseInt(b.dataset.lineRemove, 10), 0); };
    });
    d.querySelectorAll('[data-line-qty]').forEach(function (sel) {
      sel.onchange = function () { change(parseInt(sel.dataset.lineQty, 10), parseInt(sel.value, 10)); };
    });
  }
  bindLines();

  /* product form: variant selection + AJAX add */
  var bindForms = function (root) {
  (root || d).querySelectorAll('[data-product-form]').forEach(function (form) {
    if (form.dataset.formBound === '1') return;
    form.dataset.formBound = '1';
    var idInput = form.querySelector('[name="id"]');
    var submit = form.querySelector('[data-add]');
    var chosen = null;

    form.querySelectorAll('.size:not(.size--out)').forEach(function (btn) {
      on(btn, 'click', function () {
        form.querySelectorAll('.size').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        chosen = btn.dataset.variantId;
        idInput.value = chosen;
        submit.classList.remove('btn--idle');
        submit.textContent = submit.dataset.labelAdd;
        submit.dataset.size = btn.textContent.trim();

        // reflect the chosen variant's price
        var target = d.querySelector('[data-price-target]');
        if (target && btn.dataset.variantPrice) {
          var cmp = btn.dataset.variantCompare;
          target.innerHTML = cmp
            ? '<span class="price price--sale"><s class="price__was">' + cmp + '</s><span>' + btn.dataset.variantPrice + '</span></span>'
            : '<span class="price">' + btn.dataset.variantPrice + '</span>';
        }
      });
    });

    on(form, 'submit', function (e) {
      if (!drawer) return; /* no drawer: let Shopify handle the post */
      e.preventDefault();
      if (!chosen) { window.n9Toast(submit.dataset.labelSelect); return; }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: chosen, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) { window.n9Toast(submit.dataset.labelError || 'Could not add to bag'); return null; }
        return refresh().then(openDrawer);
      });
    });
  });
  };
  bindForms();

  /* sold-out notify */
  var bindNotify = function (root) {
  (root || d).querySelectorAll('[data-notify]').forEach(function (b) {
    if (b.dataset.notifyBound === '1') return;
    b.dataset.notifyBound = '1';
    b.addEventListener('click', function () {
      window.n9Toast(b.dataset.notifyMessage || 'We will write when it returns');
    });
  });
  };
  bindNotify();

  /* product gallery */
  var bindGallery = function (root) {
  (root || d).querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main] img');
    gal.querySelectorAll('[data-thumb]').forEach(function (t) {
      on(t, 'click', function () {
        gal.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (main) { main.src = t.dataset.src; main.srcset = ''; }
      });
    });
  });
  };
  bindGallery();

  /* size guide */
  var sg = d.querySelector('[data-sizeguide]');
  d.querySelectorAll('[data-sizeguide-open]').forEach(function (b) { on(b, 'click', function () { sg.classList.add('is-open'); }); });
  d.querySelectorAll('[data-sizeguide-close]').forEach(function (b) { on(b, 'click', function () { sg.classList.remove('is-open'); }); });

  /* Shopify theme-editor lifecycle: re-bind anything section-scoped */
  d.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    observeReveals(root);
    bindDrag(root);
    bindGallery(root);
    bindForms(root);
    bindNotify(root);
    syncChrome();
    if (typeof bindLines === 'function') bindLines();
  });
  d.addEventListener('shopify:section:select', function () { syncChrome(); });
  d.addEventListener('shopify:section:unload', function () { syncChrome(); });

  /* collection: tag filter + in-page search, combined */
  var cards = d.querySelectorAll('[data-card]');
  if (cards.length) {
    var filters = d.querySelectorAll('[data-filter]');
    var countEl = d.querySelector('[data-count]');
    var noMatch = d.querySelector('[data-no-matches]');
    var pager = d.querySelector('.pagination');
    var activeTag = 'all';
    var query = '';

    var run = function () {
      var shown = 0;
      Array.prototype.forEach.call(cards, function (c) {
        var tagOk = activeTag === 'all' || (c.dataset.tags || '').split(' ').indexOf(activeTag) > -1;
        var qOk = !query || (c.dataset.title || '').indexOf(query) > -1;
        var on = tagOk && qOk;
        c.hidden = !on;
        if (on) shown++;
      });
      if (countEl) countEl.textContent = shown === 1 ? '1 piece' : shown + ' pieces';
      if (noMatch) noMatch.hidden = shown !== 0;
      // paging is meaningless while a query is narrowing the page
      if (pager) pager.style.display = query ? 'none' : '';
    };

    Array.prototype.forEach.call(filters, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(filters, function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        activeTag = b.dataset.filter;
        run();
      });
    });

    var shopSearch = d.querySelector('[data-shop-search]');
    if (shopSearch) {
      shopSearch.addEventListener('input', function () {
        query = shopSearch.value.trim().toLowerCase();
        run();
      });
      var shopForm = d.querySelector('[data-shop-search-form]');
      if (shopForm) shopForm.addEventListener('submit', function (e) {
        // filter in place; only fall through to the search page if nothing matched
        if (d.querySelectorAll('[data-card]:not([hidden])').length) e.preventDefault();
      });
    }
  }
})();
